<template>
    <div class="flex justify-center flex-wrap">
        <div class='text-center'>
            <a :href='Url(templateArgs.data.licitacao_categoria_id, templateArgs.data.id)' class='btn btn-primary btn-sm btn-editar btn-w' title='Abrir'
                @click.prevent='Open(templateArgs.data.licitacao_categoria_id, templateArgs.data.id)'>
                <i class='fa fa-arrow-right'></i> Abrir
            </a>
        </div>
    </div>
</template>

<script>
export default {
    name: 'templateAbrir',
    data: () => ({
        templateArgs: {}
    }),
    methods: {
        Url (cat, id) {
            return `${this.templateArgs.vm.url}${id}`
        },
        Open (cat, id) {
            this.templateArgs.vm.$router.push(`${this.templateArgs.vm.url}${id}`)
        },
    }
}
</script>

<style lang="scss" scoped>
</style>